"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickableIcon = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
exports.ClickableIcon = components_core_1.styled.button `
  cursor: pointer;
  :focus {
    outline: 0px;
  }
  color: #001e50;
  height: 44px;
  width: 44px;
  border: 1px solid #dfe4e8;
  border-radius: 32px;
  background: #dfe4e8;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    @media (min-width: ${components_core_1.Breakpoints.b960}px) {
      background: #00b0f0;
      border-color: #00b0f0;
    }
  }
`;
